import { render } from "./Inbox.vue?vue&type=template&id=6f85eed4"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"

import "./Inbox.vue?vue&type=style&index=0&id=6f85eed4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__